<template>
	<div style="width: 100%">
		<div class="title">
			<div class="header">
				<div class="header_title-container title">
					<h1>{{ $t("schools") }}</h1>
				</div>

				<div class="header_actions">
					<div class="header_actions-container">
						<option-button
							:show="true"
							:buttons="buttons"
							@clear="handleClear"
							@archive="options.deleting = true"
							@restore="options.restoring = true"
							@add="add = true"
							:csvEntity="'organizations'"
							:csvHeader="csvHeader"
							:csvFilters="getFilters"
							:processCsv="processCsv"
						/>
					</div>
				</div>
			</div>
		</div>
		<!-- FILTER BAR -->
		<div style="display: flex; margin-bottom: 10px">
			<el-select
				v-model="filter.select"
				@change="
					() => {
						if (searching) searching = false
						this.error.splice('filter.select')
					}
				"
				filterable
				multiple
				value-key="name"
				:collapse-tags="filter.select.length > 4"
				:placeholder="$t('select-filters')"
				style="width: 40%"
				:style="{ border: error.includes('filter.select') ? '1px solid red' : '' }"
			>
				<el-option v-for="item in filter.fields" :key="item.id" :label="item.name" :value="item"> </el-option>
			</el-select>
			<el-input
				style="margin-top: auto; margin-bottom: auto; width: 60%"
				clearable
				:placeholder="$t('search-something')"
				v-model="filter.value"
				@keyup.enter.native="handleSearch(false)"
			/>
			<el-button
				type="primary"
				@click="handleSearch(false)"
				style="width: 75px; margin-left: auto; margin-right: 0"
			>
				<i class="el-icon-search" />
			</el-button>
			<el-button
				v-if="searching"
				type="warning"
				@click="handleSearch(true)"
				style="width: 75px; margin-left: auto; margin-right: 0"
			>
				<i class="el-icon-close" />
			</el-button>
		</div>
		<div v-if="schools" style="display: flex">
			<app-deleted-items :deleted_at="deleted_at" @change="v => (deleted_at = v)" />
			<app-total :start="pagination.offset" :end="pagination.offset + schools.length" :total="pagination.tot" />
		</div>
		<!-- TABLE -->
		<div :style="{ height: height + 'px' }" style="overflow-y: auto">
			<div v-loading="loading">
				<md-table v-model="schools" v-if="schools.length > 0">
					<md-table-row
						slot="md-table-row"
						slot-scope="{ item }"
						md-selectable="single"
						@click="rowClick(item)"
					>
						<md-table-cell width="25">
							<md-checkbox
								:id="item.id"
								v-model="selecteds"
								:value="item"
								@click="e => e.stopPropagation()"
							/>
						</md-table-cell>
						<md-table-cell :md-label="$t('name').toUpperCase()">
							<span v-if="!item.confirmed" style="margin-right: 5px">
								<el-tag type="warning">{{ $t("waiting-to-confirm") }}</el-tag>
							</span>
							<span
								>{{ item.name.String
								}}<img v-if="item.request_of_deletion" style="width: 30px" src="/bomb.png"
							/></span>
						</md-table-cell>
						<md-table-cell :md-label="$t('telephone').toUpperCase()" width="125">
							<span v-for="field of item.custom_field_values" :key="field.id">
								<span v-if="field.custom_field.name == 'telefono' && field.value != ''">{{
									field.value
								}}</span>
							</span>
						</md-table-cell>
						<md-table-cell :md-label="$t('address').toUpperCase()" width="200">
							<span v-for="field of item.custom_field_values" :key="field.id">
								<span v-if="field.custom_field.name == 'indirizzo' && field.value != ''">{{
									field.value
								}}</span>
								<span v-if="field.custom_field.name == 'città' && field.value != ''">
									<br />{{ field.value }}
								</span>
								<span v-if="field.custom_field.name == 'CAP' && field.value != ''">
									<br />{{ field.value }}
								</span>
								<span v-if="field.custom_field.name == 'provincia' && field.value != ''">
									<span>{{ " (" + field.value + ")" }}</span>
								</span>
							</span>
						</md-table-cell>
						<md-table-cell v-if="deleted_at" width="150" :md-label="$t('deleted-at')">
							{{ item.deleted_at ? moment(item.deleted_at).format("DD-MM-YYYY") : "" }}
						</md-table-cell>
						<md-table-cell width="25">
							<option-table-button @edit="rowClick(item)" :buttons="['edit']" placement="bottom" />
						</md-table-cell>
					</md-table-row>
				</md-table>
				<div v-else>
					<p>{{ $t("empty-result") }}</p>
				</div>
			</div>

			<app-pagination
				:tot="pagination.tot"
				:size="pagination.size"
				:offset="pagination.offset"
				@fetch="doFetch"
			/>
		</div>

		<div>
			<schools-add :show="add" @add="handleAdd" @close="add = false" />

			<div v-if="view_modal">
				<delete-confirm-modal @close="handleFunction" :title="title" :content="content" />
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import { mapGetters, mapActions } from "vuex"
import OptionButton from "@/modules/_common/button/option-button.vue"
import AppPagination from "@/modules/_common/table/app-pagination.vue"
import OptionTableButton from "@/modules/_common/button/option-table-button.vue"
import SchoolsAdd from "@/modules/users/schools/schools-components/schools-add.vue"
import AppTotal from "@/modules/_common/table/app-total.vue"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal.vue"
import DeletedItems from "@/modules/_common/table/app-deleted-items.vue"
import AppBreadcrumb from "@/modules/_common/app-breadcrumb.vue"

export default {
	components: {
		OptionButton,
		AppPagination,
		OptionTableButton,
		SchoolsAdd,
		AppTotal,
		DeleteConfirmModal,
		"app-deleted-items": DeletedItems,
		AppBreadcrumb
	},
	name: "schools-list",
	data() {
		return {
			height: window.innerHeight - 300,
			// non aggiungere i18n servono così in ita
			filter_keys: [
				"indirizzo",
				"città",
				"CAP",
				"provincia",
				"denominazione scuola",
				"codice meccanografico",
				"codice fiscale",
				"telefono"
			],
			schools: [],
			loading: true,
			add: false,
			error: [],
			filter: {
				fields: [],
				select: [],
				value: undefined
			},
			deleted_at: false,

			searching: false,
			buttons: ["add", "option", "option-csv"],
			selecteds: [],
			pagination: {
				tot: 0,
				size: 50,
				offset: 0
			},
			//OPTION-BUTTON ACTIONS
			options: {
				deleting: false,
				restoring: false
			},

			//CSV
			csvHeader: [
				this.$t("id"),
				this.$t("name"),
				this.$t("created-at"),
				this.$t("updated-at"),
				this.$t("deleted-at")
				//custom fields dinamici
			],
			csvHeaderIds: []
		}
	},
	created() {
		if (this.$route.params && this.$route.params.id != undefined) {
			this.filter_field = this.$route.params.id
			filters = {
				...filters,
				ids: [this.$route.params.id]
			}
		}

		this.doFetch(1, this.pagination.size)

		axios
			.post(
				process.env.VUE_APP_API_URL + "/api/customfields/filters",
				{ levels: [-1] },
				{
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				}
			)
			.then(res => {
				res.data.array.forEach(item => {
					if (this.filter_keys.indexOf(item.name) > -1) {
						this.filter.fields.push(item)
						this.filter.select.push(item)
					}

					this.csvHeader.push(item.name)
					this.csvHeaderIds.push(item.id)
				})
			})
			.catch(err => {
				console.error(err)
			})
	},
	watch: {
		selected: function () {
			if (this.selected == undefined) this.show_details = false
		},
		selecteds: function () {
			if (this.selecteds.length > 0) {
				if (this.selecteds.every(el => el.deleted_at != undefined)) this.buttons = ["clear", "restore"]
				else this.buttons = ["clear", "archive"]
			} else {
				this.buttons = ["add", "option", "option-csv"]
			}
		},
		filter_field: function () {
			if (this.filter_field == undefined || this.filter_field == "") {
				this.getList({})
			}
		},
		deleted_at: function () {
			this.handleSearch(this.searching)
		},

		deletingAction: function () {
			this.options.deleting = this.deletingAction
		},
		restoringAction: function () {
			this.options.restoring = this.restoringAction
		}
	},
	computed: {
		...mapGetters({
			myself: "user/user",
			custom_fields: "organization/custom_fields",
			add_subscription: "organization/add_subscription",

			deletingAction: "school/deleting",
			restoringAction: "school/restoring"
		}),
		view_modal: function () {
			for (let item of Object.keys(this.options)) {
				if (this.options[item]) return true
			}

			return false
		},
		title: function () {
			if (this.options.deleting) return this.$t("archive-item-title")
			else if (this.options.restoring) return this.$t("restoring-item-title")
		},
		content: function () {
			if (this.options.deleting) return this.$t("archive-item-content")
			else if (this.options.restoring) return this.$t("restoring-item-content")
		}
	},
	methods: {
		...mapActions({
			doMutation: "school/doMutate"
		}),
		moment,
		doFetch: function (page, size) {
			var filters = this.getFilters(true, page, size)
			this.getList(filters)
		},
		getList: function (filters) {
			if (this.searching && this.filter.select.length == 0 && this.filter.value) {
				this.error = ["filter.select"]
				return
			}
			this.schools = []
			this.loading = true

			axios
				.post(process.env.VUE_APP_API_URL + "/api/organizations/filters", filters, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.schools = res.data.array
					this.pagination.tot = res.data.count
					this.loading = false
				})
				.catch(err => {
					console.error(err)
				})
		},
		handleSearch: function (reset) {
			this.searching = !reset
			if (!this.searching) {
				this.filter.value = ""
				this.filter.select = []
			}
			this.doFetch(1, this.pagination.size)
		},
		getFilters(withFilters, page = undefined, size = undefined) {
			if (!withFilters)
				return {
					ids: [],
					value: "",
					pagination: {},
					deleted_at: true
				}

			var filters = {
				ids: [],
				value: this.filter.value == undefined ? "" : this.filter.value,
				pagination: {},
				deleted_at: this.deleted_at
			}

			this.filter.select.forEach(item => {
				filters.ids.push(item.id)
			})

			if (size && page) {
				this.pagination.size = size
				this.pagination.offset = (page - 1) * this.pagination.size
				filters.pagination.offset = this.pagination.offset
				filters.pagination.size = this.pagination.size
			}

			return filters
		},

		handleClear: function () {
			this.buttons = []
			this.selecteds = []
		},
		handleAdd: function (payload) {
			this.add = false
			this.schools.push(payload)
		},
		rowClick: async function (item) {
			await this.doMutation({ element: "school", value: item })
			this.$nextTick(() => {
				this.$goTo({ path: "/users/schools/" + item.id })
			})
		},

		closeDrawer: function () {
			this.show_details = false
			this.selected = undefined
		},

		// DA RIGUARDARE
		handleUpdate: function () {
			this.selected.custom_field_values.forEach(element => {
				for (let item of this.custom_fields) {
					if (item.name == "denominazione scuola") this.selected.name.String = item.custom_field_value.value
					if (element.custom_field_id == item.id) {
						element.value = item.custom_field_value.value
					}
				}
			})
		},

		handleFunction(value) {
			if (!value) {
				this.options = {
					deleting: false,
					restoring: false
				}
				this.doMutate({ element: "restoring", value: false })
				this.doMutate({ element: "deleting", value: false })
				return
			}
			if (this.options.deleting) this.handleDelete(value)
			else if (this.options.restoring) this.handleRestore(value)
		},

		handleMessage: function () {
			this.$message({
				message: this.$t("on-development"),
				type: "warning"
			})
		},

		handleDelete: function (value) {
			var ids = []
			if (this.selected) ids = [this.selected.id]
			this.selecteds.forEach(item => {
				if (item.deleted_at == undefined) ids.push(item.id)
			})

			if (ids.length == 0) {
				this.options.deleting = false
				this.doMutate({ element: "deleting", value: false })
				return
			}

			axios
				.delete(process.env.VUE_APP_API_URL + "/api/organizations", {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") },
					data: { ids: ids }
				})
				.then(res => {
					if (res.data) {
						this.$notification("success", this.$t("archive-success"), "", 4000)
					}
					this.selecteds.forEach(item => {
						var i = this.schools.indexOf(item)
						if (!this.deleted_at) this.schools.splice(i, 1)
						else this.schools[i].deleted_at = new Date()
					})
					if (this.selected) {
						var i = this.schools.indexOf(this.selected)
						if (!this.deleted_at) this.schools.splice(i, 1)
						else this.schools[i].deleted_at = new Date()
						this.selected = undefined
					}
				})
				.catch(err => {
					console.error(err)
				})
				.finally(_ => {
					this.options.deleting = false
					this.doMutate({ element: "deleting", value: false })
				})
		},

		handleRestore: function (value) {
			var ids = []
			this.selecteds.forEach(item => {
				if (item.deleted_at != undefined) ids.push(item.id)
			})
			if (this.selected) ids = [this.selected.id]
			if (ids.length == 0) {
				this.options.restoring = false
				this.doMutate({ element: "restoring", value: false })
				return
			}
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/organizations/restore",
					{ ids: ids },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					if (res.data) {
						this.selecteds.forEach(item => {
							var i = this.schools.indexOf(item)
							this.schools[i].deleted_at = undefined
						})
						if (this.selected) {
							var i = this.schools.indexOf(this.selected)
							this.schools[i].deleted_at = undefined
							this.selected = undefined
						}
					}
					this.$notification("success", this.$t("restored-successfully"), "", 4000)
				})
				.catch(err => {
					console.error(err)
				})
				.finally(_ => {
					this.options.restoring = false
					this.doMutate({ element: "restoring", value: false })
				})
		},

		processCsv: function (item) {
			var data = []

			data.push("id: " + item.id)
			data.push('"' + item.name.String.replace(/"/g, '""') + '"')
			data.push(item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") : "-")
			data.push(item.updated_at ? moment(item.updated_at).format("DD/MM/YYYY HH:mm:ss") : "-")
			data.push(item.deleted_at ? moment(item.deleted_at).format("DD/MM/YYYY HH:mm:ss") : "-")

			this.csvHeaderIds.forEach(id => {
				item.custom_field_values.forEach(cf => {
					if (cf.custom_field_id == id) data.push('"' + cf.value.replace(/"/g, '""') + '"')
				})
			})

			return data
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-menu";

.el-button {
	border: none;
}
</style>
